import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link, useNavigate } from 'react-router-dom';
import { User, Lock, Github, AlertCircle } from 'lucide-react';
import { AnimatedGradient } from '../components/AnimatedGradient';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
export function LoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    // Simular delay de autenticación
    setTimeout(() => {
      if (username === 'admin' && password === 'claudia123') {
        // Guardar sesión
        localStorage.setItem('isAuthenticated', 'true');
        localStorage.setItem('user', 'Administrador');
        navigate('/dashboard');
      } else {
        setError('Usuario o contraseña incorrectos');
      }
      setIsLoading(false);
    }, 500);
  };
  return <div className="min-h-screen w-full relative flex items-center justify-center p-4" data-id="element-265">
      <AnimatedGradient data-id="element-266" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className="w-full max-w-md" data-id="element-267">
        <div className="bg-[#FDF8F3]/90 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/50 p-8 md:p-10" data-id="element-268">
          {/* Header */}
          <div className="text-center mb-8" data-id="element-269">
            <Link to="/" className="inline-flex items-center gap-3 mb-6 group" data-id="element-270">
              <img src="https://cdn.magicpatterns.com/uploads/6der9p7cTuhPYDgtJnKRAY/Group_1448.svg" alt="Danke Consulting" className="h-10 group-hover:scale-105 transition-transform duration-300" data-id="element-271" />
            </Link>
            <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-272">
              Bienvenido
            </h1>
            <p className="text-gray-600" data-id="element-273">
              Ingresa tus credenciales para acceder
            </p>
          </div>

          {/* Error Message */}
          {error && <motion.div initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} className="mb-6 p-3 bg-red-50 border border-red-200 rounded-xl flex items-center gap-2 text-red-700 text-sm" data-id="element-274">
              <AlertCircle className="w-4 h-4 flex-shrink-0" data-id="element-275" />
              {error}
            </motion.div>}

          {/* Form */}
          <form className="space-y-5" onSubmit={handleSubmit} data-id="element-276">
            <Input label="Usuario" type="text" placeholder="admin" value={username} onChange={e => setUsername(e.target.value)} icon={<User className="w-4 h-4" data-id="element-278" />} data-id="element-277" />

            <div data-id="element-279">
              <Input label="Contraseña" type="password" placeholder="••••••••" value={password} onChange={e => setPassword(e.target.value)} icon={<Lock className="w-4 h-4" data-id="element-281" />} data-id="element-280" />
              <div className="flex justify-end mt-2" data-id="element-282">
                <Link to="/forgot-password" className="text-xs font-medium text-orange-600 hover:text-orange-700 hover:underline" data-id="element-283">
                  ¿Olvidaste tu contraseña?
                </Link>
              </div>
            </div>

            <Button className="w-full" size="lg" isLoading={isLoading} data-id="element-284">
              Iniciar sesión
            </Button>
          </form>

          {/* Divider */}
          <div className="relative my-8" data-id="element-285">
            <div className="absolute inset-0 flex items-center" data-id="element-286">
              <div className="w-full border-t border-gray-200" data-id="element-287"></div>
            </div>
            <div className="relative flex justify-center text-sm" data-id="element-288">
              <span className="px-2 bg-[#FDF8F3] text-gray-500" data-id="element-289">
                O continúa con
              </span>
            </div>
          </div>

          {/* Social Login */}
          <div className="grid grid-cols-1 gap-4" data-id="element-290">
            <Button variant="social" icon={<svg className="w-4 h-4" viewBox="0 0 24 24" data-id="element-292">
                  <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" data-id="element-293" />
                  <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" data-id="element-294" />
                  <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" data-id="element-295" />
                  <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" data-id="element-296" />
                </svg>} data-id="element-291">
              Google
            </Button>
          </div>

          {/* Footer */}
          <p className="mt-8 text-center text-sm text-gray-600" data-id="element-297">
            ¿No tienes cuenta?{' '}
            <Link to="/register" className="font-semibold text-gray-900 hover:underline" data-id="element-298">
              Regístrate
            </Link>
          </p>
        </div>
      </motion.div>
    </div>;
}